export default "__VITE_ASSET__522e248a__"